import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class ProxyHistoryAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'proxyhistory';
}

export default new ProxyHistoryAPI();
